import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import i18n from "./i18n"; // tu configuración de i18next
import { I18nextProvider } from "react-i18next";
import { Services } from "./repositories/clients/Services";
import * as serviceWorker from "./serviceWorker";

// Clarity script (lo de siempre)
(function (c, l, a, r, i, t, y) {
  c[a] =
    c[a] ||
    function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
  t = l.createElement(r);
  t.async = 1;
  t.src = "https://www.clarity.ms/tag/" + i;
  y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);
})(window, document, "clarity", "script", Services.CLARITY.path);

// Render principal
ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={<div>Loading translations...</div>}>
      <App />
    </Suspense>
  </I18nextProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();